import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as types from './store/mutations-types'
import FastClick from 'fastclick'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import cookie from 'vux/src/tools/cookie/index.js'

import { AUTHURL } from '@/services/consts'

Vue.config.productionTip = false

Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
FastClick.attach(document.body)

const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)
let isPush = false
let endTime = Date.now()
let methods = ['push', 'go', 'replace', 'forward', 'back']

document.addEventListener('touchend', () => {
endTime = Date.now()
})
methods.forEach(key => {
let method = router[key].bind(router)
router[key] = function (...args) {
isPush = true
method.apply(null, args)
}
})

function isWeixin () {
if (process.env.NODE_ENV === 'development') {
return true
}
let ua = navigator.userAgent.toLowerCase()
let wx = ua.match(/MicroMessenger/i)
let iswindow = ua.match(/WindowsWechat/i)
return !!(wx && wx[0] === 'micromessenger' && !iswindow)
}

router.beforeEach((to, from, next) => {
if (to.name === 'NotWeChat' || to.name === 'Fail') {
next()
return
}

if (!isWeixin()) {
next({ name: 'NotWeChat' })
return false
}
if (to.name !== 'NotWeChat' && !isWeixin()) {
}

if (to.name === 'Login') {
next()
return false
}


if (/code=/.test(window.location.search)) {
let code = window.location.search.split(/\?|&|=/g)[2]
window.location.replace(`${window.location.origin}/#/login/${code}`)
return false
}





if (!store.state.user.id) {

let openid = cookie.get('openid')
cookie.set('beforeLoginUrl', to.fullPath)

if (openid && openid !== 'null' && openid !== 'undefined') {
store.dispatch(types.UPDATEUSER, { id: openid })
next({ name: 'Login', replace: true })
} else {
cookie.remove('openid')
window.location.replace(AUTHURL)
}
return false
}


if (to.matched.some(record => !record.meta.anonymous) && !store.state.user.userName) {
cookie.set('beforeLoginUrl', to.fullPath)
next({ name: 'Login', replace: true })
return false
}

if (store.state.user.userName && to.name === 'Login') {
next('/')
return false
}

store.dispatch(types.UPDATELOADINGSTATUS, { isLoading: true })

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)
if (toIndex) {
if (!fromIndex || parseInt(toIndex, 10) > parseInt(fromIndex, 10) || (toIndex === '0' && fromIndex === '0')) {
store.dispatch(types.UPDATEDIRECTION, { direction: 'forward' })
} else {
if (!isPush && (Date.now() - endTime) < 377) {
store.dispatch(types.UPDATEDIRECTION, { direction: '' })
} else {
store.dispatch(types.UPDATEDIRECTION, { direction: 'reverse' })
}
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.dispatch(types.UPDATEDIRECTION, { direction: 'forward' })
}

next()
})

router.afterEach(to => {
isPush = false
store.dispatch(types.UPDATELOADINGSTATUS, { isLoading: false })
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js